<navigation-phone class="navigation flex-none box-border" [selectedId]="selectedPage">
	<button
		class="navigation-item flex items-center justify-center"
		[navigationElement]="keys.DASHBOARD"
		(click)="navigateTo(keys.DASHBOARD)"
	>
		<i [ngClass]="navigationIcon(keys.DASHBOARD)"></i>
	</button>

	<button
		class="navigation-item flex items-center justify-center"
		[navigationElement]="keys.CHAT_AI"
		(click)="navigateTo(keys.CHAT_AI)"
	>
		<i [ngClass]="navigationIcon(keys.CHAT_AI)"></i>
	</button>

	<button
		class="navigation-item flex items-center justify-center"
		[navigationElement]="keys.CREATE_NODE"
		(click)="navigateTo(keys.CREATE_NODE)"
	>
		<i [ngClass]="navigationIcon(keys.CREATE_NODE)"></i>
	</button>

	<button
		class="navigation-item flex items-center justify-center"
		[navigationElement]="keys.SEARCH"
		(click)="navigateTo(keys.SEARCH)"
	>
		<i [ngClass]="navigationIcon(keys.SEARCH)"></i>
	</button>

	<button
		class="navigation-item flex items-center justify-center"
		[navigationElement]="keys.PROFILE"
		(click)="navigateTo(keys.PROFILE)"
	>
		<reach-user-thumbnail
			class="border border-line-250 rounded-circle w-[calc(var(--fs-icon)_+_4px)] h-[calc(var(--fs-icon)_+_4px)]"
			[useInitials]="true"
			[user]="user$ | async"
		>
			<i class="icon-contact"></i>
		</reach-user-thumbnail>
	</button>
</navigation-phone>

@if (loading) {
	<div
		class="loading-indicator top-0 left-0 w-full h-full flex absolute items-center justify-center backdrop-menu z-11 opacity-0"
	>
		<reach-logo-loader [spinning]="true"></reach-logo-loader>
	</div>
}
